<div class="passwordless_signup">
  <div
  *ngIf="showSpinner; else templateRegisration"
  [mmTestTarget]="'registration-type-spinner'"
  class="passwordless_signup__spinner"
>
  <mm-spinner diameter="50"></mm-spinner>
</div>

<ng-template #templateRegisration>
 <div class="passwordless_signup__options">


   <div class="passwordless_signup__options__item" (click)="personalSignup()">
     <div>
       <div class="passwordless_signup__options__item__icon">
        <mm-icon name="registration-type-personal"></mm-icon>

       </div>
       <div class="passwordless_signup__options__item__title">
        {{"PAGES.AUTH.REGISTRATION_TYPE.PRIVATE.TITLE" | translate}}
       </div>
     </div>

     <div class="passwordless_signup__options__item__icon_arrow">
       <mm-icon name="arrow-right"></mm-icon>

     </div>
   </div>
   <div class="passwordless_signup__options__item" (click)="businessSignup()">
     <div>
       <div class="passwordless_signup__options__item__icon">
         <mm-icon name="registration-type-business"></mm-icon>


       </div>
       <div class="passwordless_signup__options__item__title">
         {{"PAGES.AUTH.REGISTRATION_TYPE.BUSINESS.TITLE" | translate}}
       </div>
     </div>

     <div class="passwordless_signup__options__item__icon_arrow">
       <mm-icon name="arrow-right"></mm-icon>

     </div>
   </div>
   <div class="passwordless_signup__options__item" (click)="businessMetroSignup()">
     <div >
       <div class="passwordless_signup__options__item__icon">
         <mm-icon [isCurrentColor]="false" name="registration-type-metro"></mm-icon>

       </div>
       <div class="passwordless_signup__options__item__title">
        {{"PAGES.AUTH.REGISTRATION_TYPE.BUSINESS_METRO.TITLE" | translate}}
       </div>
     </div>

     <div class="passwordless_signup__options__item__icon_arrow">
       <mm-icon name="arrow-right"></mm-icon>

     </div>
   </div>

 </div>

  <div class="idam-register__legal-text">
    <span>
{{"PAGES.AUTH.REGISTER.LEGAL_TEXT.PWD" | translate}}
    </span>
    <br /><br />
      <span
        [innerHTML]="
          'PAGES.AUTH.REGISTER.LEGAL_TEXT.TNC'
            | translate: tier1SignupLegalTextParams
        "
      ></span>

    <br /><br />
  </div>
  <div
    class="idam-register__extra-links"
    [innerHTML]="
        'PAGES.AUTH.REGISTER.EXTRA_LINKS'
          | translate: tier1SignupLegalExtraLinks
      "
  ></div>
</ng-template>
</div>
